const projectCardContent = [
    {
        title: 'AvaliAqui',
        description: 'Plataforma web para avaliação de professores. AvaliAqui visa transparência para que o universitário possa selecionar o professor que melhor atende seu perfil de estudante.',
        link: 'https://github.com/alaodev/avalia_aqui'
    },
    {
        title: 'DSCovid',
        description: 'Visualzador de Dados | Casos de Covid-19 nos estados brasileiros. Trabalho desenvolvido para matéria Tecnologia e Construção de Software do curso de Ciência da Computação - PUC GO.',
        link: 'https://github.com/alaodev/ds_covid'
    },
    {
        title: 'Maratona de Desenvolvimento - ZG Soluções',
        description: 'Finalista na Maratona de Desenvolvimento da ZG Soluções. Honrado em dividir esse pódio com meus colegas Aurélio, Paulo, Kaio e Wandersom.',
        link: 'https://www.linkedin.com/posts/alaodev_esse-foi-o-p%C3%B3dio-da-maratona-de-desenvolvimento-activity-6669396017076547584-K0Z5'
    },
    {
        title: 'HACKING.HELP COVID-19',
        description: 'Participante do primeiro Hackathon Online Global do Hacking.Rio.',
        link: 'https://www.linkedin.com/posts/alaodev_fleets-activity-6670799016403456000-KA-a'
    },
];

export default projectCardContent;